var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellDownloadFw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.5713C16 15.7986 15.9097 16.0166 15.7489 16.1774C15.5882 16.3381 15.3702 16.4284 15.1429 16.4284H4.85714C4.62981 16.4284 4.4118 16.3381 4.25105 16.1774C4.09031 16.0166 4 15.7986 4 15.5713V4.42843C4 4.2011 4.09031 3.98309 4.25105 3.82234C4.4118 3.66159 4.62981 3.57129 4.85714 3.57129H13.4286C13.6517 3.57161 13.8659 3.65894 14.0257 3.81472L15.74 5.46215C15.8218 5.54193 15.8869 5.63727 15.9314 5.74257C15.9758 5.84787 15.9988 5.96099 15.9989 6.07529L16 15.5713Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5V7.5",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5L10 13L12.5 10.5",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellDownloadFw);
export default __webpack_public_path__ + "static/media/icn_table_cell_download_fw.a6cc6e8e0b0eda6868394f1dc31a3593.svg";
export { ForwardRef as ReactComponent };